import React from "react";
import MachinesList from "./MachinesList";
import { useMachine } from "../../providers/MachineDataProvider";

const MachineParentComponent: React.FC = () => {
    const {
      machineDB,
        locationsDB,
        managersDB,
        regionDB,
        blendersDB,
        boardsDB,
        cupHolderDB,
        machineStatusDB,
        tubeShieldsDB,
        marketSegmentDB,
        locationTypeDB,
        hardwareVersionDB,
        customerDB,
        loading,
    } = useMachine();

    if (loading) {
        return <div className="loading-indicator">Loading...</div>;
    }

    return (
        <MachinesList
            machines={machineDB}
            locations={locationsDB}
            users={managersDB}
            regions={regionDB}
            hardwareVersions={hardwareVersionDB} // Pass empty array or fetch if needed
            blenders={blendersDB}
            boards={boardsDB}
            marketSegment={marketSegmentDB}
            cupHolders={cupHolderDB}
            locationTypes={locationTypeDB}
            machineStatus={machineStatusDB}
            tubeShields={tubeShieldsDB}
            customers={customerDB}
        />
    );
};

export default MachineParentComponent;